var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.banners.slides)?_c('BannerSwiper',{attrs:{"banners":_vm.banners.slides,"delay":_vm.banners.banner.delay,"showSearch":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }